export const KPI_THEMES = {
  default: { bg: '#fff7ed', iconBg: '#ffedd5', icon: '#ea580c' },
  sea: { bg: '#eff6ff', iconBg: '#bfdbfe', icon: '#2563eb' },
  air: { bg: '#f5f3ff', iconBg: '#ede9fe', icon: '#8b5cf6' },
  rail: { bg: '#fefce8', iconBg: '#fef08a', icon: '#ca8a04' },
  road: { bg: '#ecfdf5', iconBg: '#bbf7d0', icon: '#16a34a' }
};

export const TRANSPORT_MODE_KPI_THEME = {
  sea: 'sea',
  air: 'air',
  rail: 'rail',
  road: 'road'
};

export function getKpiThemeIconColor(theme) {
  return KPI_THEMES[theme]?.icon || '#cccccc';
}

export function getTransportModeChartColor(mode) {
  const theme = TRANSPORT_MODE_KPI_THEME[mode?.toLowerCase()];
  return theme ? getKpiThemeIconColor(theme) : '#cccccc';
}
